module.exports = __webpack_public_path__ + "static/img/bcg.f06fdd21.webp";